// extracted by mini-css-extract-plugin
module.exports = {"color":"SessionTypeColorBadge_color__3BGpU","color--with-border":"SessionTypeColorBadge_color--with-border__22J0l"};